export default function ListItem(props:{icon?:JSX.Element, children:any}){
    return <div className='flex p-5 my-3 border-solid border-2 border-stone-300 rounded-lg items-center'>
        {props.icon && <div className='flex-none w-14 text-center text-stone-400'>
            {props.icon}
        </div>}
        <div className='flex-initial'>
            {props.children}
        </div>
    </div>
}